import HttpHelper from "../../../helpers/httpHelper";

const USER_API_URL = process.env.REACT_APP_USER_API_URL;

class DeliveryAddressAPI {
    static CreateDeliveryAddress(req) {
        let url = `${USER_API_URL}/delivery-address`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static GetDeliveryAddress(req) {
        let url = `${USER_API_URL}/delivery-address`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static GetSellerAddress(req) {
        let url = `${USER_API_URL}/seller-address`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static GetDeliveryAddressById(id) {
        let url = `${USER_API_URL}/delivery-address/${id}`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static UpdateDeliveryAddressById(req) {
        let url = `${USER_API_URL}/delivery-address/${req._id}`;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static DeleteDeliveryAddressById(id) {
        let url = `${USER_API_URL}/delivery-address/${id}`;
        return HttpHelper.httpRequest(url, "DELETE", {});
    }

    static GetShippingAmount(req) {
        let url = `${USER_API_URL}/shipping-amount/`;
        return HttpHelper.httpRequest(
            url,
            "POST",
            {},
            {
                ids: req,
            }
        );
    }
}

export default DeliveryAddressAPI;
